var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"f-s-16"},[_vm._v("优惠券"),_c('span',{staticClass:"f-l-r",staticStyle:{"color":"#73787F"}},[_vm._v("无")])])])}]

export { render, staticRenderFns }